export default defineNuxtRouteMiddleware((to) => {
    if (!process.client || to.path !== '/vet-onboarding/') return

    const doctorRef = to.query.ref
    if (typeof doctorRef !== 'string' || !doctorRef) return

    localStorage.setItem(DOCTOR_REF_STORAGE_KEY, doctorRef)
    localStorage.removeItem('clinic_ref')

    const query = {...to.query}
    delete query.ref

    return navigateTo({path: to.path, query}, {redirectCode: 302})
})
